export const UNIT = '1.5vw'
export const UNIT_HORIZONTAL = '1.5vw'
export const UNIT_VERTICAL = '5px'

